import { html } from "lit";
import { ActionStatus } from "../../../../common/constants/action-status";
import { StoreState } from "../../../../store/store.interface";
import { getLoginURLWithRedirectUrlToCurrentPage } from "../../../../common/utils/login-utils";
import emit from "../../../../common/events";
import store from "../../../../store/store";
import { getUserDataForUserAnalytics } from "../../../user-profile/user-profile.selectors";

export const isInitializeCartSuccess = (state: StoreState) => 
  getInitializeCartStatus(state) === ActionStatus.succeeded;

export const isInitializeCartFailed = (state: StoreState) => 
  getInitializeCartStatus(state) === ActionStatus.failed;

export const getInitializeCartStatus = (state: StoreState) => 
  state.shopCartState.initializeCartMagentoResponse.status;

export const doRedirect = (redirectUrl: string) => {
  window.location.href = redirectUrl;
}

export const isValidateUserConnectLicenseActiveSuccess = (state: StoreState) =>
  state.shopCartState.validateLoggedInUserConnectLicenseResponse.status === ActionStatus.succeeded;

export const isValidateUserConnectLicenseActiveFailed = (state: StoreState) =>
  state.shopCartState.validateLoggedInUserConnectLicenseResponse.status === ActionStatus.failed;

export const isValidateUserConnectLicenseActiveIdleOrLoading = (state: StoreState) =>
  [ActionStatus.loading, ActionStatus.idle].includes(state.shopCartState.validateLoggedInUserConnectLicenseResponse.status);

export const validateUserConnectLicenseErrorMessage = (state: StoreState) =>
  state.shopCartState.validateLoggedInUserConnectLicenseResponse?.error?.response?.message;

export const loginLink = (element, loggedIn: boolean) => 
  html`<a href=${getLoginURLWithRedirectUrlToCurrentPage()} @click=${(e) => captureConnectUserLoginAnalytics(e, loggedIn, element)}>log in</a>`;


function captureConnectUserLoginAnalytics(event: Event, loggedIn: boolean, element): void {
  event.preventDefault();
  const state = store.getState() as StoreState;

  emit({
    element: element,
    name: 'click',
    detail: {
      eventName: `mhecomm-connect-looseleaf-upsell-user-login-link-clicked`,
      label: 'User Log In',
      url: window.location.href,
      comp: 'login',
      ...(loggedIn && {
        user: getUserDataForUserAnalytics(state, true),
      }),
    }
  });

  window.location.href = (event.currentTarget as HTMLAnchorElement).href;
}
